import { getAnalyticsData, indexSectorList } from '../../apis';
import { getBulkBlockDealData, getFIIDIIMFData, getMergerDemergerData, getNearestToBookValue, getPremiumDiscount } from '../../apis/cds';
import { _getAppWaveScannerDetails } from '../../controllers';
import { SCREENERS } from '../actionTypes';



export const getAppWaveScreenersDetails = () => async (dispatch) => {
    try {
        const objResp = await _getAppWaveScannerDetails();
        dispatch(getAppWaveScreenersDetailsSuccess(objResp?.data));
    } catch (error) {
        console.error(error.message);
        if (error?.response?.data) {
            dispatch(getAppWaveScreenersDetailsFailure(error?.response?.data));
        } else {
            dispatch(getAppWaveScreenersDetailsFailure({}));
        }
    }
};

export const getIndexSectorList = () => async (dispatch) => {
    try {
        const objResp = await indexSectorList();
        dispatch(getIndexSectorListSuccess(objResp?.data?.result));
    } catch (error) {
        dispatch(getIndexSectorListFailure([]));
        console.log(error);
    }
};

export const getScreenersGridData = (arrPayLoad) => async (dispatch) => {
    try {
        //call two api for high and low
        if (arrPayLoad[0]?.RedisKeyPrefix !== "" && arrPayLoad[0]?.RedisKeyPrefix !== undefined) {
            const objResp1 = await getAnalyticsData({ RedisKeyPrefix: arrPayLoad[0]?.RedisKeyPrefix, segmentId: arrPayLoad[0].segmentId, indexSector: arrPayLoad[0].indexSector, callSector: arrPayLoad[0]?.callSector ? arrPayLoad[0]?.callSector : '-', month: arrPayLoad[0].month });
            if (arrPayLoad[0]?.RedisKeyPrefix === "AdvanceDecline_" && objResp1?.data?.status === true && Object?.keys(objResp1?.data?.result)?.length) {
                let advance = [];
                let decline = [];
                Object.keys(objResp1?.data?.result)?.forEach((each) => {
                    if (objResp1?.data?.result?.[each]?.advance?.length) {
                        advance = advance.concat(objResp1?.data?.result?.[each]?.advance);
                    }
                    if (objResp1?.data?.result?.[each]?.decline?.length) {
                        decline = decline.concat(objResp1?.data?.result?.[each]?.decline);
                    }
                });
                dispatch(getScreenersGridDataSuccess({ advance: advance, decline: decline }));

            } else {
                dispatch(getScreenersGridDataSuccess(objResp1?.data?.result));
            }
        }

    } catch (error) {
        console.log(error.message);
        dispatch(getScreenersGridDataFailure([]));
    }
};
export const getNearestBookValueSuccess = (payload) => {
    // Need to make data binding here and add action type in reducer
    return { type: SCREENERS.GET_NEAR_BOOK_VALUE_DETAILS_SUCCESS, payload };
};

export const getNearestBookValue = (arrPayLoad) => async (dispatch) => {
    try {
        const objResp1 = await getNearestToBookValue(arrPayLoad);

        dispatch(getNearestBookValueSuccess(objResp1?.data?.ResponseObject?.resultset));
        dispatch(getScreenersGridDataSuccess(objResp1?.data?.ResponseObject?.resultset));
    } catch (error) {
        console.log(error.message);
        dispatch(getNearestBookValueSuccess([]));
        dispatch(getScreenersGridDataFailure([]));
    }
};



export const getPremiumDiscountData = (arrPayLoad) => async (dispatch) => {
    try {
        const objResp1 = await getPremiumDiscount(arrPayLoad);
        dispatch(getPremiumDiscountDataSuccess(objResp1?.data?.ResponseObject?.resultset));
        dispatch(getScreenersGridDataSuccess(objResp1?.data?.ResponseObject?.resultset));

    } catch (error) {
        console.log(error.message);
        dispatch(getPremiumDiscountDataFailure([]));
        dispatch(getScreenersGridDataFailure([]));
    }
};

export const getPremiumDiscountDataSuccess = (payload) => {
    return { type: SCREENERS.GET_PREMIUM_DISCOUNT_DETAILS_SUCCESS, payload };
};

export const getPremiumDiscountDataFailure = (payload) => {
    return { type: SCREENERS.GET_PREMIUM_DISCOUNT_DETAILS_FAILURE, payload };
};

export const getAppWaveScreenersDetailsSuccess = (payload) => {
    // Need to make data binding here and add action type in reducer
    return { type: SCREENERS.GET_APP_WAVE_SCREENERS_DETAILS_SUCCESS, payload };
};

export const getAppWaveScreenersDetailsFailure = (payload) => {
    return { type: SCREENERS.GET_APP_WAVE_SCREENERS_DETAILS_FAILURE, payload };
};
export const getScreenersGridDataSuccess = (payload) => {
    return { type: SCREENERS.GET_SCREENERS_GRID_DATA_SUCCESS, payload };
};
export const getScreenersGridDataFailure = (payload) => {
    return { type: SCREENERS.GET_SCREENERS_GRID_DATA_FAILURE, payload };
};
export const getIndexSectorListSuccess = (payload) => {
    return { type: SCREENERS.GET_INDEX_SECTOR_LIST_SUCCESS, payload };
};
export const getIndexSectorListFailure = (payload) => {
    return { type: SCREENERS.GET_INDEX_SECTOR_LIST_FAILURE, payload };
};

export const getScreenersGridDays = () => {
    return { type: SCREENERS.GET_SCREENERS_GRID_DAYS, payload: {} };
};

export const getScreenersGridPivot = () => {
    return { type: SCREENERS.GET_SCREENERS_GRID_PIVOT, payload: {} };
};

export const getScreenersGridWeek = () => {
    return { type: SCREENERS.GET_SCREENERS_GRID_WEEK, payload: {} };
};
export const setBIsGridDataShow = (payload) => {
    return { type: SCREENERS.SET_IS_GRID_DATA_SHOW, payload: payload };
};
export const setArrCategoryOptions = (payload) => {
    return { type: SCREENERS.SET_CATEGORY_OPTIONS, payload: payload };
};
export const setArrActiveScreenerData = (payload) => {
    return { type: SCREENERS.SET_ACTIVE_SCANNERS_DATA, payload: payload };
};
export const setArrFavouritesScreeners = (payload) => {
    return { type: SCREENERS.SET_FAVOURITE_SCREENERS, payload: payload };
};
export const setObjselectedScreener = (payload) => {
    return { type: SCREENERS.SET_SELECTED_SCREENER, payload: payload };
};
export const setSelectedTab = (payload) => {
    return { type: SCREENERS.SET_SELECTED_TAB, payload: payload };
};
export const setSelectedCategory = (payload) => {
    return { type: SCREENERS.SET_SELECTED_CATEGORY, payload: payload };
};
export const setPrevScanner = (payload) => {
    return { type: SCREENERS.GET_PREV_SCANNER, payload: payload };
};

//Ameersha N - 10-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners --Start
export const getFiiDiiMfDataActions = (sType, jtenantToken) => async (dispatch) => {
    const objResp = await getFIIDIIMFData({ type: sType, jtenantToken: jtenantToken });
    if (sType === "FII") {
        dispatch(fiiDataSuccess(objResp?.data?.ResponseObject?.resultset));
    } else if (sType === "DII") {
        dispatch(DIIDataSuccess(objResp?.data?.ResponseObject?.resultset));
    } else if (sType === "MF") {
        dispatch(mfDataSuccess(objResp?.data?.ResponseObject?.resultset));
    } else { }

};
//Ameersha N - 10-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners --End
//Ameersha N - 10-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners --Start
export const getMergerandAcqDataAction = (objPayload) => async (dispatch) => {
    try {
        let objResp = await getMergerDemergerData(objPayload);
        dispatch(getMergerAndAqSuccess(objResp?.data?.ResponseObject?.resultset));
    } catch (error) {

    }
};
//Ameersha N - 10-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners --End

//Ameersha N - 10-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners --Start
export const getBulkOrBlockDataAction = (objPayload) => async (dispatch) => {
    try {
        let objResp = await getBulkBlockDealData(objPayload);
        if (objPayload?.dealType === 'block') {
            dispatch(getBlockDataSuccess(objResp?.data?.ResponseObject?.resultset));
        } else if (objPayload?.dealType === 'bulk') {
            dispatch(getBulkDataSuccess(objResp?.data?.ResponseObject?.resultset));
        } else { }
    } catch (error) {

    }
};
//Ameersha N - 10-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners --End
//Ameersha N - 10-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners --Start
export const getBulkDataSuccess = (payload) => {
    return { type: SCREENERS?.GET_BULK_SUCCESS, payload };
};

export const getBlockDataSuccess = (payload) => {
    return { type: SCREENERS?.GET_BLOCK_SUCCESS, payload };
};

export const getMergerAndAqSuccess = (payload) => {
    return { type: SCREENERS?.GET_MERGER_ACQ_SUCCESS, payload };
};

export const DIIDataSuccess = (payload) => {
    return { type: SCREENERS?.GET_DII_SUCCESS, payload };
};

export const fiiDataSuccess = (payload) => {
    return { type: SCREENERS?.GET_FII_SUCCESS, payload };
};

export const mfDataSuccess = (payload) => {
    return { type: SCREENERS?.GET_MF_SUCCESS, payload };
};
//Ameersha N - 10-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners --End
